import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Constantes } from '../../shared/constant/constantes';
import { DataAccordion } from '../../shared/entities/data-accordion';
import { InformacionSerie } from '../../shared/entities/informacion-serie';
import { MenuEstadistica } from '../../shared/entities/menu-estadistica';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { UtilidadGeneraTabla } from '../../shared/utilities/utilidad-genera-tabla';
import { UtilidadMenuEstadisticas } from '../../shared/utilities/utilidad-menu-estadisticas';

@Component({
  selector: 'app-web-service',
  templateUrl: './web-service.component.html',
  styleUrls: ['./web-service.component.css']
})
export class WebServiceComponent implements OnInit {

    public utilidadTabla: UtilidadGeneraTabla = new UtilidadGeneraTabla();
    public constantes: Constantes = new Constantes();
    public ume:UtilidadMenuEstadisticas = new UtilidadMenuEstadisticas();

    public listaCatalogo: Array<MenuEstadistica> = new Array();
    public listaDataAccordion: Array<DataAccordion> = new Array();

    constructor(private service: VisualizadorService, private router: Router, private location: Location) { }

    ngOnInit(): void {
        const currentUrl = this.location.path();
        this.service.generaTagsHtmlSEO('Servicios web - SDMX','Servicios web - SDMX','servicios web, web, web services',currentUrl);
        this.generaMenuDinamico();
        this.service.setWindowScroll(0, 0);
    }

    private generaMenuDinamico() {
        this.service.getMenuXOpcion('WEB_SERVICES').subscribe({
            next: (listaCatalogoMenu) => {
                this.listaCatalogo = listaCatalogoMenu;
                this.listaDataAccordion = this.getMenuAccordion(this.listaCatalogo);  
            },
            error: (error) => {
              console.log("Error inesperado en generaMenuDinamico", error);
            }
      
          });
    }

    public getMenuAccordion(catalogoSelect: Array<MenuEstadistica>): Array<DataAccordion> {
        let result: Array<DataAccordion> = new Array();
        let dataAccordion: DataAccordion;
        catalogoSelect.forEach((catalogo) => {
            dataAccordion = new DataAccordion();
            dataAccordion.nombre = catalogo.nombre;
            let hijo: DataAccordion;
            catalogo.menuHijos.forEach((menuHijo) => {
                hijo = new DataAccordion();
                hijo.nombre = menuHijo.nombre;
                hijo.id = menuHijo.id;
                hijo.enlace_reporte_tabla = menuHijo.enlace_reporte_tabla;
                hijo.enlace_pagina_externa = menuHijo.enlace_pagina_externa;
                if (menuHijo.menuHijos.length > 0) {
                    let tablaDatos: DataAccordion = this.generaTablaDatos(menuHijo.menuHijos);
                    hijo.encabezadoTabla = tablaDatos.encabezadoTabla;
                    hijo.datosTablaSerie = tablaDatos.datosTablaSerie;
                }else{
                    hijo.display = false;
                    hijo.iconDisplay = '►';
                }
                dataAccordion.menuHijos.push(hijo);
            });
            result.push(dataAccordion);
        });
        return result;
    }

    private generaTablaDatos(infoTablaMenu: Array<MenuEstadistica>): DataAccordion {
        let tablaResultado: DataAccordion = new DataAccordion();

        let encabezados: any = this.constantes.ENCABEZADO_GENERAL;
        tablaResultado.encabezadoTabla = encabezados;

        infoTablaMenu.forEach(element => {
            let datosTablaSerie: Array<InformacionSerie> = new Array();
            for (var i = 0; i < encabezados.length; i++) {
                let infoSerie: InformacionSerie = new InformacionSerie();
                if (i == 0) {
                    infoSerie.indicador = element.nombre;
                    infoSerie.enlace_pagina_externa = element.enlace_pagina_externa;
                    infoSerie.clasificacion = this.constantes.TIPO_URL_EXTERNA;
                    datosTablaSerie.push(infoSerie);
                } else {
                    infoSerie.indicador = '-'
                    datosTablaSerie.push(infoSerie);
                }
            }
            tablaResultado.datosTablaSerie.push(datosTablaSerie);
        });
        return tablaResultado;
    }

    public expandedChange(value:any){
        console.log('value: ',value);
    }
}
